import { render, staticRenderFns } from "./HeaderBlock.vue?vue&type=template&id=3c91cbcc&scoped=true"
import script from "./HeaderBlock.vue?vue&type=script&lang=js"
export * from "./HeaderBlock.vue?vue&type=script&lang=js"
import style0 from "./HeaderBlock.vue?vue&type=style&index=0&id=3c91cbcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c91cbcc",
  null
  
)

export default component.exports